import React, { Component } from 'react';
import Button from 'material-ui/Button';
import { withStyles } from 'material-ui/styles';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from 'material-ui/Dialog';

import * as InspectionActions from '../../inspection/inspection.actions';
import * as ReportsActions from '../../reports/reports.actions';
import { getCurrentUser } from '../../user/user.selectors';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 150,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  hide: {
    display: 'none',
  },
});

class XlsxReportsConfirm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
      submitSuccess: false,
      downloadUrl: ''
    };
  }

  handleCancel = () => {
    this.props.onRequestClose();
    this.setState({
      submitted: false,
      submitSuccess: false,
    });
  };

  handlePrint = () => {
    const { exportInspectionsAsXlsx, reports } = this.props;
    exportInspectionsAsXlsx(reports)
      .then(action => {
        console.log(action)
        if (action && action.response && action.response.status === 'ok') {
          this.setState({
            submitted: true,
            submitSuccess: true,
            downloadUrl: action.response.downloadUrl
          });
        } else {
          this.setState({
            submitted: true,
            submitSuccess: false,
          });
        }
      })
      .catch(error => {
        this.setState({
          submitted: true,
          submitSuccess: false,
        });
      });
  };

  userEmail = () => {
    const { currentUser } = this.props;
    if (currentUser) {
      return '(' + currentUser.email + ')';
    }
    return '';
  };

  renderRequest() {
    return (
      <div>
        <DialogContent>
          <DialogContentText>
            Luo Excel-raportti valituista raporteista?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel}>Peruuta</Button>
          <Button onClick={this.handlePrint} color="primary">
            Luo
          </Button>
        </DialogActions>
      </div>
    );
  }

  renderSuccess() {
    return (
      <div>
        <DialogContent>
          <DialogContentText>
            Raportti valmis ladattavaksi. <br /><br />
            {this.state.downloadUrl ? <a href={this.state.downloadUrl} target="_blank">Lataa</a> : 'Luodaan raporttia'}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel} color="primary">
            Ok
          </Button>
        </DialogActions>
      </div>
    );
  }

  renderFailure() {
    return (
      <div>
        <DialogTitle>Vienti ei onnistu</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Excelin luonti ei onnistunut. Tarkista
            verkkoyhteytesi ja yritä myöhemmin uudelleen.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel}>Takaisin</Button>
        </DialogActions>
      </div>
    );
  }

  render() {
    const { open } = this.props;
    const { submitted, submitSuccess } = this.state;
    if (!open) {
      return null;
    }
    return (
      <Dialog onRequestClose={this.handleCancel} open={open}>
        {!submitted
          ? this.renderRequest()
          : submitSuccess ? this.renderSuccess() : this.renderFailure()}
      </Dialog>
    );
  }
}

const mapStateToProps = state => {
  const currentUser = getCurrentUser(state);

  return {
    currentUser,
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    Object.assign({}, InspectionActions, ReportsActions)
  )(withStyles(styles)(XlsxReportsConfirm))
);



// WEBPACK FOOTER //
// ./src/modules/reports/components/XlsxReportsConfirm.js